import { Injectable } from '@angular/core';
import { OktaAuthService } from '@okta/okta-angular';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { GoogleAnalyticsService } from '../google_analytics/google-analytics.service';
import { roles } from '../../model/roles_Enum.model';

@Injectable()
export class UserDataService {
  isAuthenticated: boolean;
  public logger =  new BehaviorSubject({});
  public userObs = new BehaviorSubject<any>({});
  public loggerDetails$ = this.logger.asObservable();
  public userData$= this.userObs.asObservable();
  
  constructor( public oktaAuth: OktaAuthService,
               private googleAnalyticsService: GoogleAnalyticsService
  ){}
  
  async getLoggerData(): Promise<any>{
    const isAuthenticated = await this.oktaAuth.isAuthenticated();
        this.isAuthenticated = isAuthenticated;
        console.log('IS authentication from user data service file ', this.isAuthenticated);
        if(this.isAuthenticated){
          const userClaims = await this.oktaAuth.getUser();
          this.googleAnalyticsService.emitEvent('LogIn', 'username' + ' ' + userClaims.given_name, "EmailID" + ' ' + userClaims.email, 10);
          const userRoles = userClaims['groups'].filter( (group) => group.includes('PC') );
          const role = userRoles[0];
          const roleVal = this.findRoleVal(role);
          const token = await this.oktaAuth.getAccessToken();
          const userData={};
          userData['lastName'] = userClaims.family_name;
          userData['loginId'] = userClaims.preferred_username;
          userData['userRoles']=userRoles;
          userData['userRole']=role;
          userData['userRoleVal'] = roleVal;
          userData['userName']=userClaims.preferred_username;
          userData['accessToken']=token;
          userData['isAuthenticated'] = isAuthenticated;
          userData['email'] = userClaims.preferred_username;
          this.userObs.next(userData);
        }
     
  }
  findRoleVal(role: string): number{
    if(role == 'PC Site Admin'){
      return roles.siteAdmin;
    }else if(role == 'PC PAR Admin'){
      return roles.PARAdmin;
    }else if(role == 'PC Client'){
      return roles.Client;
    }else if(role == 'PC Resolution Manager'){
      return roles.ResolutionManager;
    }else if(role == 'PC PAR Vendor Relations'){
      return roles.QAC;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user/userData.service.ts